export default [
  {
    key: 'invite_sent',
    displayName: 'Sent carrier invites'
  },
  // TODO: at a later stage (when multiple carriers are invited) there will be an "accepted" state as well
  {
    key: 'awarded',
    displayName: 'Carrier accepted'
  },
  {
    key: 'start_job',
    displayName: 'Start job'
  },
  {
    key: 'origin_check_in',
    displayName: 'Origin checkin'
  },
  {
    key: 'load_pickup_photo_count',
    displayName: 'Pick-up photos'
  },
  {
    key: 'load_pickup_signature',
    displayName: 'Pick-up signature'
  },
  {
    key: 'in_transit',
    displayName: 'In Transit'
  },
  {
    key: 'destination_check_in',
    displayName: 'Destination check-in'
  },
  {
    key: 'load_dropoff_photo_count',
    displayName: 'Unloading photos'
  },
  {
    key: 'load_dropoff_signature_name',
    displayName: 'Drop-off signature'
  },
  {
    key: 'finish_job',
    displayName: 'Finish job'
  },
  /*
  {
    key: 'invoice_generated',
    displayName: 'Invoice generated'
  },
  */
  {
    key: 'job_closed',
    displayName: 'Job closed'
  },
  {
    key: 'stored_to_blockchain',
    displayName: 'Stored to blockchain'
  }
]
